var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// /Users/akshetpandey/workspace/thriller-server/~/core-js/library/modules/_core.js
// module id = 35
// module chunks = 168707334958949